import React, { useEffect, useState } from 'react';
import { locales } from '../../translations/locales';
import Manning from './modalSgoVehicle/Manning';
import Status from './modalSgoVehicle/Status';
import Message from './modalSgoVehicle/Message';
import Remove from './modalSgoVehicle/Remove';
import EmptyModal from './modalSgoVehicle/EmptyModal';

const Bloc = {
    Manning,
    Status,
    Message,
    Remove,
    EmptyModal,
};

const ModalSgoVehicle = (props) => {
    const { locale, vehicle, listStatus, buildings, ModuleRP, players } = props;

    const [menuOpen, setMenuOpen] = useState('EmptyModal');

    const Component = Bloc[menuOpen];

    const closeModal = () => {
        setMenuOpen('EmptyModal');
    };

    useEffect(() => {

    }, [menuOpen, vehicle, players]);

    return (
        <div>
            <div
                className="modal"
                id="modalVehicle"
                data-backdrop="static"
                data-keyboard="false"
                tabIndex="-1"
                aria-labelledby="modalTitle"
                aria-hidden="true"
            >
                <div className='modal-dialog modal-dialog-scrollable'>
                    <div className='modal-content'>
                        <div className='modal-header'>
                            <h5 className='modal-title' id='modalVehicle-Title'>
                                {locales[locale].config.manageVehicle} {vehicle.name}
                            </h5>
                            <button type='button' className='close' data-dismiss='modal' aria-label='Close' id='modalRpClose' onClick={closeModal}>
                                <span aria-hidden='true'>&times;</span>
                            </button>
                        </div>
                        <div className='modal-body text-center' id='modalVehicle-body'>
                            <div className='row'>
                                <div className='col-6'>
                                    <button
                                        type='button'
                                        className={`btn btn-${menuOpen === 'Manning' ? 'warning' : 'secondary'} m-1`}
                                        onClick={() => setMenuOpen('Manning')}
                                    >
                                        {locales[locale].sgo.manning.toUpperCase()}
                                    </button>
                                </div>
                                <div className='col-6'>
                                    <button
                                        type='button'
                                        className={`btn btn-${menuOpen === 'Status' ? 'primary' : 'secondary'} m-1`}
                                        onClick={() => setMenuOpen('Status')}
                                    >
                                        {locales[locale].config.status.toUpperCase()}
                                    </button>
                                </div>
                                <div className='col-6'>
                                    <button
                                        type='button'
                                        className={`btn btn-${menuOpen === 'Message' ? 'info' : 'secondary'} m-1`}
                                        onClick={() => setMenuOpen('Message')}
                                    >
                                        {locales[locale].sgo.message.toUpperCase()}
                                    </button>
                                </div>
                                <div className='col-6'>
                                    <button
                                        type='button'
                                        className={`btn btn-${menuOpen === 'Remove' ? 'danger' : 'secondary'} m-1`}
                                        onClick={() => setMenuOpen('Remove')}
                                    >
                                        {locales[locale].sgo.removeVehicle.toUpperCase()}
                                    </button>
                                </div>
                            </div>
                            <Component
                                locale={locale}
                                vehicle={vehicle}
                                listStatus={listStatus}
                                buildings={buildings}
                                ModuleRP={ModuleRP}
                                players={players}
                            />
                        </div>
                        <div className='modal-footer' id='modalVehicle-footer'>
                            <button type='button' className='btn btn-secondary' data-dismiss='modal' onClick={closeModal}>
                                {locales[locale].close}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ModalSgoVehicle;
